import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Col, Form, Input, Row, Select } from "antd";

import { required, validarEmail } from "../../services/forms";
// import http from "../../services/http";
import { modalSuccess } from "../../services/notifications";
import { actions, getToken, hasPermission } from "../../services/security";
import { BASEURL } from "../../services/url";
import http from "../../services/http";

const UsuariosForm = (props) => {
  let navigate = useNavigate();
  const [form] = Form.useForm();

  const { id } = props;

  const disabled =
    id === "nuevo"
      ? !hasPermission(actions.UsuariosCrear)
      : !hasPermission(actions.UsuariosEditar);

  const [loading, setLoading] = useState(false);
  const [perfiles, setPerfiles] = useState([]);

  useEffect(() => {
    async function getForm() {
      let response = await http.get(`${BASEURL}/perfiles`);
      if (response) {
        const data = response.data;
        setPerfiles(data.list);
      }

      if (id === "nuevo") {
        return;
      }

      response = await http.get(`${BASEURL}/User/usuarios/${id}`);
      if (response) {
        const data = response.data;
        form.setFieldsValue(data);
      }
    }
    getForm();
  }, [id]);

  const onClickBack = () => {
    navigate("/usuarios");
  };

  const onClickSave = async (values) => {
    setLoading(true);

    const response =
      id === "nuevo"
        ? await http.post(`${BASEURL}/User/usuarios/`, values)
        .catch((error) => {
          if (error.response.status) {
            modalSuccess(
              "Error",
              "El nombre de usuario ya existe"
            );
          }
        })
        : await http.put(`${BASEURL}/User/usuarios/${id}`, values)
        .catch((error) => {
          if (error.response.status) {
            modalSuccess(
              "Error",
              "El nombre de usuario ya existe"
            );
          }
        });

    setLoading(false);

    if (response) {
      await modalSuccess(
        "Usuario guardado",
        id === "nuevo"
          ? "El usuario fue creado exitosamente"
          : "El usuario fue modificado exitosamente"
      );
      navigate("/usuarios");
    }
  };

  return (
    <Form layout="vertical" form={form} onFinish={onClickSave}>
      <Row gutter={16}>

        <Col xs={24}>
          <Form.Item label="Nombre Usuario" name="nombreUsuario" rules={[required]}>
            <Input autoComplete='off' disabled={disabled} />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item label="Nombre" name="nombre" rules={[required]}>
            <Input autoComplete='off' disabled={disabled} />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item label="Apellido" name="apellido" rules={[required]}>
            <Input autoComplete='off' disabled={disabled} />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item label="Email" name="email" rules={[required]}>
            <Input autoComplete='off' disabled={disabled} />
          </Form.Item>
        </Col>


        <Col xs={24}>
          <Form.Item label="Perfiles" name="perfiles" rules={[required]}>
            <Select
              mode="multiple"
              allowClear
              showSearch
              optionFilterProp="children"
              maxTagCount="responsive"
              disabled={disabled}
            >
              {perfiles.map((option, index) => (
                <Select.Option key={index} value={option.id}>
                  {option.nombre}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <div className="actions">
        <Button type="text" onClick={onClickBack}>
          Volver
        </Button>
        {!disabled && (
          <Button type="primary" htmlType="submit" loading={loading}>
            {!loading && "Guardar"}
          </Button>
        )}
      </div>
    </Form>
  );
};

export default UsuariosForm;
